define('OutSystems/ClientRuntime/Logger',["require", "exports", "./ClientInfo", "./Exceptions", "./StorageProvider", "./VersionDefinition"], function (require, exports, ClientInfo_1, Exceptions, StorageProvider_1, VersionDefinition) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.serializeObjectForLog = exports.setDeviceDetails = exports.error = exports.log = exports.trace = exports.setTracingEnabled = exports.hadSessionLogs = exports.hasPendingLogs = exports.setBatchSize = exports.flushLogsToServerIfOnline = exports.flushLogsToStorage = exports.flushLogsToServer = exports.enableFallbackStorage = exports.setNetworkStatusChecker = exports.setOfflineStorage = exports.setPostLogsFunction = exports.initialize = exports.forceTracing = exports.DummyLogStorage = exports.ServerLogAppender = exports.LogTypes = exports.LoggerStorage = void 0;
    exports.LoggerStorage = {
        hasTracingEnabled: new StorageProvider_1.StorageObject(StorageProvider_1.StorageType.Persistent, "HasTracingEnabled"),
        fallbackLogStorage: new StorageProvider_1.StorageObject(StorageProvider_1.StorageType.Persistent, "FallbackLogStorage", []),
    };
    exports.LogTypes = {
        Error: "error",
        General: "general",
        Trace: "trace",
    };
    var ServerLogAppender = (function () {
        function ServerLogAppender(postLog) {
            this.postLog = postLog;
        }
        ServerLogAppender.prototype.writeLog = function (logMessage) {
            return this.writeLogBatch([logMessage]);
        };
        ServerLogAppender.prototype.writeLogBatch = function (logBatch) {
            return this.postLog(logBatch);
        };
        return ServerLogAppender;
    }());
    exports.ServerLogAppender = ServerLogAppender;
    var DummyLogStorage = (function () {
        function DummyLogStorage() {
        }
        DummyLogStorage.prototype.writeLog = function (logMessage) {
            return Promise.resolve(undefined);
        };
        DummyLogStorage.prototype.writeLogBatch = function (logBatch) {
            return Promise.resolve(undefined);
        };
        DummyLogStorage.prototype.countLogs = function () {
            return Promise.resolve(0);
        };
        DummyLogStorage.prototype.getLogs = function (numberRows) {
            return Promise.resolve([]);
        };
        DummyLogStorage.prototype.popLogs = function (numberRows) {
            return Promise.resolve([]);
        };
        DummyLogStorage.prototype.removeLogs = function (numberRowsToDelete) {
            return Promise.resolve(undefined);
        };
        return DummyLogStorage;
    }());
    exports.DummyLogStorage = DummyLogStorage;
    var LOGGER_MODULE_NAME = "Logger";
    var DEFAULT_BATCH_SIZE = 10;
    var TIMEOUT_BASE_TIME = 200;
    var TIMEOUT_BASE_FACTOR = 1.2;
    var TIMEOUT_MAX_EXPONENT = 40;
    var ERROR_COUNT_THRESHOLD = 5;
    var SERVER_PING_TIMEOUT = 5000;
    var MESSAGE_MAX_SIZE = 2000;
    var logs;
    var batchSize;
    var timeout;
    var errorCount;
    var pingRetries;
    var tracingEnabled;
    var processLogBlocked = false;
    var isProcessingLogs;
    var retrieveLogs;
    var isOnline;
    var isServerAvailable;
    var placedLogsInFallbackStorage;
    var retrievedLogsFromFallbackStorage;
    var hasOnlineAppenderSet;
    var hasOfflineStorageSet;
    var hasFallbackStorageEnabled;
    var offlineStoragePromise;
    var onlineAppenderPromise;
    var networkStatus;
    var onSetOfflineStorage;
    var onSetOnlineAppender;
    var deviceDetails;
    function initialize() {
        logs = [];
        batchSize = DEFAULT_BATCH_SIZE;
        timeout = TIMEOUT_BASE_TIME;
        errorCount = 0;
        pingRetries = 0;
        isProcessingLogs = false;
        retrieveLogs = false;
        isOnline = false;
        isServerAvailable = false;
        placedLogsInFallbackStorage = false;
        retrievedLogsFromFallbackStorage = false;
        hasOnlineAppenderSet = false;
        hasOfflineStorageSet = false;
        hasFallbackStorageEnabled = false;
        deviceDetails = "";
        onlineAppenderPromise = new Promise(function (resolve, reject) {
            onSetOnlineAppender = function (appender) {
                hasOnlineAppenderSet = true;
                resolve(appender);
                retrieveLogs = true;
            };
        });
        offlineStoragePromise = new Promise(function (resolve, reject) {
            onSetOfflineStorage = function (storage) {
                hasOfflineStorageSet = true;
                resolve(storage);
                retrieveLogs = true;
            };
        });
    }
    exports.initialize = initialize;
    function setPostLogsFunction(postLogs) {
        var onlineAppender = new ServerLogAppender(postLogs);
        onSetOnlineAppender(onlineAppender);
    }
    exports.setPostLogsFunction = setPostLogsFunction;
    function setOfflineStorage(offlineStorage) {
        onSetOfflineStorage(offlineStorage);
    }
    exports.setOfflineStorage = setOfflineStorage;
    function setNetworkStatusChecker(networkStatusChecker) {
        networkStatusChecker.onOnline(function () { return onOnline(); });
        networkStatusChecker.onOffline(function () { return onOffline(); });
        isOnline = networkStatusChecker.isOnline();
        isServerAvailable = true;
        retrieveLogs = isOnline;
        networkStatus = networkStatusChecker;
    }
    exports.setNetworkStatusChecker = setNetworkStatusChecker;
    function enableFallbackStorage() {
        hasFallbackStorageEnabled = true;
        retrieveLogsFromFallbackStorage();
        tracingEnabled = exports.LoggerStorage.hasTracingEnabled.get();
    }
    exports.enableFallbackStorage = enableFallbackStorage;
    function processLogs() {
        if (processLogBlocked) {
            return;
        }
        isProcessingLogs = true;
        if (retrieveLogs && hasOfflineStorageSet) {
            retrieveLogsFromStorage();
            return;
        }
        Promise.resolve()
            .then(function () {
            if (isOnline && isServerAvailable && hasOnlineAppenderSet) {
                return sendLogsToServer();
            }
            else if (hasOfflineStorageSet) {
                return writeToOfflineStorage();
            }
            else {
                isProcessingLogs = false;
                return;
            }
        })
            .catch(function () {
            isProcessingLogs = false;
        });
    }
    function needsProcessing() {
        return !isEmpty() || retrieveLogs;
    }
    function sendLogsToServer() {
        if (errorCount >= ERROR_COUNT_THRESHOLD && networkStatus) {
            isServerAvailable = false;
            pingRetries = 0;
            pingServerAvailability();
            setTimeout(function () { return processLogs(); }, timeout);
            return;
        }
        return onlineAppenderPromise.then(function (appender) {
            return writeLogs(appender, batchSize);
        });
    }
    function writeToOfflineStorage(numLogs) {
        if (numLogs === void 0) { numLogs = batchSize; }
        return offlineStoragePromise.then(function (offlineStorage) {
            return writeLogs(offlineStorage, numLogs);
        });
    }
    function writeLogs(appender, numberLogs) {
        if (isEmpty()) {
            isProcessingLogs = false;
            return Promise.resolve(undefined);
        }
        var currentLogs = logs.slice(0, numberLogs);
        return appender
            .writeLogBatch(currentLogs)
            .then(function () {
            logs.splice(0, currentLogs.length);
            errorCount = 0;
            if (needsProcessing()) {
                setTimeout(function () { return processLogs(); }, timeout);
            }
            else {
                isProcessingLogs = false;
            }
        })
            .catch(function () {
            logs.splice(0, currentLogs.length);
            logs = logs.concat(currentLogs);
            errorCount++;
            setTimeout(function () { return processLogs(); }, calculateRetryTime(errorCount));
        });
    }
    function flushLogsToServer() {
        onOnline();
    }
    exports.flushLogsToServer = flushLogsToServer;
    function flushLogsToStorage(blockProcessLog) {
        if (blockProcessLog === void 0) { blockProcessLog = false; }
        processLogBlocked = blockProcessLog;
        if (hasOfflineStorageSet) {
            return writeToOfflineStorage(logs.length);
        }
        else if (hasFallbackStorageEnabled) {
            var currentLogs = logs;
            if (placedLogsInFallbackStorage) {
                currentLogs = exports.LoggerStorage.fallbackLogStorage.get().concat(logs);
            }
            exports.LoggerStorage.fallbackLogStorage.set(currentLogs);
            placedLogsInFallbackStorage = true;
            logs = [];
        }
        return Promise.resolve(undefined);
    }
    exports.flushLogsToStorage = flushLogsToStorage;
    function retrieveLogsFromFallbackStorage() {
        var sessionLogs = exports.LoggerStorage.fallbackLogStorage.get();
        if (sessionLogs.length !== 0) {
            pushBatch(sessionLogs);
            if (isOnline) {
                exports.LoggerStorage.fallbackLogStorage.remove();
            }
            else {
                networkStatus.onOnline(function () { return exports.LoggerStorage.fallbackLogStorage.remove(); });
                offlineStoragePromise.then(function () { return exports.LoggerStorage.fallbackLogStorage.remove(); });
            }
            retrievedLogsFromFallbackStorage = true;
        }
    }
    function retrieveLogsFromStorage() {
        return offlineStoragePromise.then(function (offlineStorage) {
            offlineStorage
                .getLogs()
                .then(function (retrievedLogs) {
                logs = retrievedLogs.concat(logs);
                if (retrievedLogs.length > 0) {
                    offlineStorage
                        .removeLogs(retrievedLogs.length)
                        .then(function () {
                        retrieveLogs = false;
                        setTimeout(function () { return processLogs(); }, timeout);
                    })
                        .catch(function () {
                        logs.splice(0, retrievedLogs.length);
                        setTimeout(function () { return processLogs(); }, timeout);
                    });
                }
                else {
                    retrieveLogs = false;
                    setTimeout(function () { return processLogs(); }, timeout);
                }
            })
                .catch(function () {
                setTimeout(function () { return processLogs(); }, timeout);
            });
        });
    }
    function onOnline() {
        isOnline = true;
        isServerAvailable = true;
        retrieveLogs = true;
        errorCount = 0;
        if (!isProcessingLogs) {
            processLogs();
        }
    }
    function onOffline() {
        isOnline = false;
        isServerAvailable = false;
        retrieveLogs = false;
        errorCount = 0;
        if (!isProcessingLogs) {
            processLogs();
        }
    }
    var flushLogsToServerIfOnline = function () {
        if (isOnline) {
            flushLogsToServer();
        }
    };
    exports.flushLogsToServerIfOnline = flushLogsToServerIfOnline;
    function pingServerAvailability() {
        if (!networkStatus) {
            return;
        }
        networkStatus
            .ping(SERVER_PING_TIMEOUT)
            .then(function () {
            pingRetries = 0;
            onOnline();
        })
            .catch(function () {
            if (isOnline && !isServerAvailable) {
                pingRetries++;
                setTimeout(function () {
                    pingServerAvailability();
                }, calculateRetryTime(pingRetries));
            }
        });
    }
    function setBatchSize(newBatchSize) {
        batchSize = newBatchSize;
    }
    exports.setBatchSize = setBatchSize;
    function isEmpty() {
        return logs.length === 0;
    }
    function push(logData) {
        logs.push(truncateLog(logData));
        if (!isProcessingLogs) {
            processLogs();
        }
    }
    function pushBatch(logs) {
        logs.forEach(function (log) { return push(log); });
    }
    function truncateLog(logData) {
        logData.message = !!logData.message ? logData.message.substring(0, MESSAGE_MAX_SIZE) : logData.message;
        logData.stack = !!logData.stack ? logData.stack.substring(0, MESSAGE_MAX_SIZE) : logData.stack;
        return logData;
    }
    function calculateRetryTime(numberRetries) {
        var exponent = Math.min(numberRetries, TIMEOUT_MAX_EXPONENT);
        return Math.pow(TIMEOUT_BASE_FACTOR, exponent) * timeout;
    }
    function hasPendingLogs() {
        return !isEmpty();
    }
    exports.hasPendingLogs = hasPendingLogs;
    function hadSessionLogs() {
        return retrievedLogsFromFallbackStorage;
    }
    exports.hadSessionLogs = hadSessionLogs;
    function setTracingEnabled(enableTracing) {
        if (enableTracing === void 0) { enableTracing = false; }
        tracingEnabled = enableTracing;
        try {
            exports.LoggerStorage.hasTracingEnabled.set(tracingEnabled);
        }
        catch (e) {
            trace(LOGGER_MODULE_NAME, "Error saving the new value of 'tracingEnabled' property in the local storage. " + e);
        }
    }
    exports.setTracingEnabled = setTracingEnabled;
    function trace(callerModule, message) {
        if (callerModule && message && (tracingEnabled || exports.forceTracing)) {
            var name_1 = "";
            if (typeof callerModule === "string") {
                name_1 = callerModule;
            }
            else {
                name_1 = callerModule.constructor.name;
                if (name_1 === "Function") {
                    name_1 = callerModule.name;
                }
            }
            var traceMessage = void 0;
            if (typeof message === "string") {
                traceMessage = message;
            }
            else {
                traceMessage = message();
            }
            innerLog(name_1, traceMessage, exports.LogTypes.Trace);
        }
    }
    exports.trace = trace;
    function log(module, message) {
        innerLog(module, message, exports.LogTypes.General);
    }
    exports.log = log;
    function error(module, messageOrError, error) {
        var message = "";
        var stack = "";
        if (typeof messageOrError === "string") {
            message = messageOrError;
        }
        else {
            message = Exceptions.getMessage(messageOrError);
            stack = Exceptions.getStack(messageOrError);
        }
        if (error) {
            message += "\n" + Exceptions.getMessage(error);
            stack += (stack ? "\n" : "") + Exceptions.getStack(error);
        }
        innerLog(module, message, exports.LogTypes.Error, stack);
    }
    exports.error = error;
    function setDeviceDetails(isNative) {
        if (tracingEnabled && isNative) {
            getDeviceDetails();
            trace(LOGGER_MODULE_NAME, "Device details initialized");
        }
        else {
            trace(LOGGER_MODULE_NAME, "Device details not initialized: isNative = [".concat(isNative, "] tracingEnabled = [").concat(tracingEnabled, "]"));
        }
    }
    exports.setDeviceDetails = setDeviceDetails;
    function serializeObjectForLog(val, depth, replacer, space, onGetObjID) {
        if (depth === void 0) { depth = 3; }
        replacer = replacer || trimObject;
        depth = isNaN(+depth) ? 1 : depth;
        var recursMap = new WeakMap();
        function _build(val, depth, o, a, r) {
            return !val || typeof val !== "object"
                ? val
                : ((r = recursMap.has(val)),
                    recursMap.set(val, true),
                    (a = Array.isArray(val)),
                    r
                        ? (o = (onGetObjID && onGetObjID(val)) || null)
                        : JSON.stringify(val, function (k, v) {
                            if (a || depth > 0) {
                                if (replacer) {
                                    v = replacer(k, v);
                                }
                                if (!k) {
                                    return (a = Array.isArray(v)), (val = v);
                                }
                                o = o || (a ? [] : {});
                                o[k] = _build(v, a ? depth : depth - 1);
                            }
                        }),
                    o === void 0 ? (a ? [] : "(...)") : o);
        }
        return JSON.stringify(_build(val, depth), null, space);
    }
    exports.serializeObjectForLog = serializeObjectForLog;
    function trimObject(key, value) {
        var maxArrayElems = 10;
        var maxProps = 10;
        var maxStringLength = 25;
        if (key === "") {
            if (Array.isArray(value)) {
                var arrValue = value;
                if (arrValue.length >= maxArrayElems) {
                    arrValue = arrValue.slice(0, maxArrayElems - 1);
                    arrValue.push("(...)");
                }
                return arrValue;
            }
            var obj = cloneObjectWithPropLimit(value, maxProps);
            return obj;
        }
        else if (typeof value === "string") {
            var stringValue = value;
            return stringValue.length > maxStringLength
                ? stringValue.substring(0, maxStringLength - 6) + " (...)"
                : stringValue;
        }
        return value;
    }
    function cloneObjectWithPropLimit(object, maxProps) {
        var numProps = 0;
        var wasTrucated = false;
        var obj = Object.keys(object).reduce(function (result, key) {
            numProps++;
            if (numProps <= maxProps) {
                result[key] = object[key];
            }
            else {
                wasTrucated = true;
            }
            return result;
        }, {});
        if (wasTrucated) {
            obj["..."] = "(...)";
        }
        return obj;
    }
    function innerLog(userDefinedModuleName, message, logType, stack) {
        if (!logType || logType.trim() === "") {
            throw new Error("Logger: Error sending log. LogType must be defined.");
        }
        var now = new Date().toISOString();
        var moduleString = userDefinedModuleName ? userDefinedModuleName + " " : "";
        var serverMessage = "".concat(message).concat(deviceDetails);
        var consoleMessage = "".concat(moduleString, "[").concat(now, "]: ").concat(message, " ").concat(stack ? "\n" + stack : "");
        var logMessage = {
            instant: now,
            logType: logType,
            message: serverMessage,
            moduleName: userDefinedModuleName,
            stack: stack,
        };
        if (logType === exports.LogTypes.Error) {
            logMessage.extra = VersionDefinition.toObject();
            console.error(consoleMessage);
        }
        else {
            console.log(consoleMessage);
        }
        push(logMessage);
    }
    function getDeviceDetails() {
        if (!deviceDetails) {
            var clientInfo = (0, ClientInfo_1.getClientInfo)();
            if (clientInfo && clientInfo.device) {
                var device = clientInfo.device;
                deviceDetails = " [".concat(device.platform, "|").concat(device.version, "|").concat(device.manufacturer, "|").concat(device.model, "|").concat(device.uuid, "|").concat(device.cordova, "]");
            }
        }
        return deviceDetails;
    }
    initialize();
});
//# sourceMappingURL=Logger.js.map;
